const ACCEPTANCE_TEST_ENVIRONMENT_COOKIE = 'hs_selenium';

/**
 *
 * @returns true if current runtime environment is a Selenium acceptance test, false otherwise.
 */
export const getIsInAcceptanceTestEnvironment = () => document.cookie.includes(ACCEPTANCE_TEST_ENVIRONMENT_COOKIE);